module.exports = function() {

	// instagram
	var instagramGallery = {
		init: function(){
			instagramGallery.getDataJson();
		},
		getDataJson: function() {
			$.ajax({
				url: '/instagram.php',
					type: 'POST',
					dataType: 'json'
			})
			.done(function(data) {
				(data.length > 0) && instagramGallery.insertHtml(data);
			})
			.fail(function() {
				alert("ページの読み込みに失敗しました。もう一度アクセスし直してください。")
			});
		},
		insertHtml: function(data) {
			var dataList = "";
			$.each(data, function(i, item){
				var imageUrl = item.images.low_resolution.url,
						link = item.link;
				dataList += '<li><a href="' + link + '" target="_blank"><img src="' + imageUrl + '" alt="edit."></a></li>';
			});

			var dataHtml = '<ul>' + dataList + '</ul>';
			$('.js_instagramGallery').html(dataHtml);
		}
	}

	if($('.js_instagramGallery').length > 0) {
		instagramGallery.init();
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/gallery.js
// module id = 7
// module chunks = 0